import * as React from 'react';
import { useCallback } from 'react';
import { connectRange } from 'react-instantsearch-core';
import { ButtonDropdown, Price } from '@grandvisionhq/common';
import { useIntl } from '@grandvisionhq/state';
import { ClearFacetFilter } from '../ClearFacetFilter/ClearFacetFilter.js';
import FacetContainer from '../FacetContainer/FacetContainer.js';
import FacetInputPriceRange from './FacetInputPriceRange.js';

var ConnectedFacetInputPriceRange = connectRange(ConnectedFacetInputPriceRange$1);
const roundPrice = (value)=>{
    return Math.round(value / 100);
};
function ConnectedFacetInputPriceRange$1({ facet , refine , min , max , currentRefinement  }) {
    const clear = useCallback(()=>refine({
            min,
            max
        })
    , [
        min,
        max
    ]);
    const intl = useIntl();
    const clearButtonEnabled = currentRefinement.min !== min || currentRefinement.max !== max;
    const ariaLabel = `${intl.getLabel('search.filterBy')} ${intl.getLabel(facet.labelKey || facet.id).toLowerCase()}`;
    if (min === max) {
        return null;
    }
    return /*#__PURE__*/ React.createElement("div", {
        className: "connected-facet-input-range"
    }, /*#__PURE__*/ React.createElement(ButtonDropdown, {
        focusItemOnHover: false,
        loop: true,
        "aria-label": ariaLabel,
        "data-t": "connected-facet-input-range-button"
    }, /*#__PURE__*/ React.createElement(ButtonDropdown.Button, {
        className: "connected-facet-input-range__button"
    }, intl.getLabel(facet.labelKey || facet.id)), /*#__PURE__*/ React.createElement(ButtonDropdown.Content, {
        type: "generic",
        restoreFocus: true
    }, /*#__PURE__*/ React.createElement(FacetContainer, {
        ClearButton: /*#__PURE__*/ React.createElement(ButtonDropdown.InteractiveWrapper, {
            isDisabled: !clearButtonEnabled,
            childElement: "button"
        }, /*#__PURE__*/ React.createElement(ClearFacetFilter, {
            onClear: clear,
            isDisabled: !clearButtonEnabled,
            label: intl.getLabel('search.filters.clear', {
                defaultValue: 'clear'
            })
        })),
        title: /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(Price, {
            value: roundPrice(currentRefinement.min),
            currency: intl.currency,
            centAmount: false
        }), ' – ', /*#__PURE__*/ React.createElement(Price, {
            value: roundPrice(currentRefinement.max),
            currency: intl.currency,
            centAmount: false
        }))
    }, /*#__PURE__*/ React.createElement(ButtonDropdown.InteractiveWrapper, {
        childElement: "slider"
    }, /*#__PURE__*/ React.createElement(FacetInputPriceRange, {
        min: min,
        max: max,
        value: currentRefinement,
        facetLabel: intl.getLabel(facet.labelKey || facet.id),
        onChange: refine,
        renderNumber: roundPrice
    }))))));
}

export { ConnectedFacetInputPriceRange$1 as ConnectedFacetInputPriceRange, ConnectedFacetInputPriceRange as default };
//# sourceMappingURL=ConnectedFacetInputPriceRange.js.map
